import React from "react";
import "./Profile.css";
import Typed from "react-typed";
import Particles from "react-particles-js";

function Profile() {
    return (
      <div className="profile">
          <div className="profile__reactTyped">
            <Particles
              className="react__particles"
              params={{
                particles: {
                  number: {
                    value: 40,
                  },
                  size: {
                    value: 5,
                  },
                },
                interactivity: {
                  events: {
                    onhover: {
                      enable: true,
                      mode: "repulse",
                    },
                  },
                },
              }}
            />
            <div className="react__typed">
              <h1 className="name">
                <Typed
                  strings={["Hi! I'm Yahiya Khan."]}
                  typeSpeed={50}
                ></Typed>
              </h1>
              <h3 style={{ color: "white" }} className="name__beneath">
                <Typed
                  strings={["Student", "Web Designer", "Web Developer"]}
                  typeSpeed={50}
                  backSpeed={50}
                  loop
                ></Typed>
              </h3>
            </div>
          </div>
            </div>
    );
}

export default Profile;
